module.exports = __webpack_public_path__ + "static/img/huanbanguanli.0707dbda.svg";